




































































































































































































































































































































































































































































import {roleDeptTreeselect} from '@/api/system/dept';
import {getDicts} from '@/api/system/dict/data';
import {roleMenuTreeselect, treeselect as menuTreeselect} from '@/api/system/menu';
import {listRole} from '@/api/system/role';
import {api} from '@/plugins/api';
import {msgSuccess} from '@/plugins/element';
import {download} from '@/utils/ruoyi';
import {ElForm} from 'element-ui/types/form';
import {ElTree} from 'element-ui/types/tree';
import {EffectsContext} from 'v-schema-form';
import Vue from 'vue';

export default Vue.extend({
  name: 'Role',
  data() {
    return {
      searchFormSchema: {
        props: {inline: true},
        fields: {
          roleName: {
            title: '角色名称',
            type: 'string',
            placeholder: '请输入角色名称',
            props: {
              style: {
                width: '240px',
                clearable: true
              }
            },
            nativeEvents: {
              // @ts-ignore
              enter: this.handleQuery
            }
          },
          roleKey: {
            title: '权限字符',
            type: 'string',
            placeholder: '请输入权限字符',
            props: {
              style: {
                width: '240px',
                clearable: true
              }
            },
            nativeEvents: {
              // @ts-ignore
              enter: this.handleQuery
            }
          },
          status: {
            title: '状态',
            type: 'select',
            placeholder: '角色状态',
            props: {
              labelProperty: 'dictLabel',
              valueProperty: 'dictValue',
              style: {
                width: '240px',
                clearable: true
              }
            }
          },
          '[start, end]': {
            type: 'daterange',
            title: '创建时间',
            props: {
              style: {
                width: '240px',
                clearable: true
              },
              startPlaceholder: '开始日期',
              endPlaceholder: '结束日期'
            }
          }
        }
      },
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 角色表格数据
      roleList: [] as any,
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      menuExpand: false,
      menuNodeAll: false,
      deptExpand: true,
      deptNodeAll: false,
      // 日期范围
      dateRange: [],
      // 状态数据字典
      statusOptions: [{
        value: 0,
        label: '正常'
      }, {
        value:1,
        label: '停用'
      }],
      // 数据范围选项
      dataScopeOptions: [
        {
          value: '1',
          label: '全部数据权限'
        },
        {
          value: '2',
          label: '自定数据权限'
        },
        {
          value: '3',
          label: '本部门数据权限'
        },
        {
          value: '4',
          label: '本部门及以下数据权限'
        },
        {
          value: '5',
          label: '仅本人数据权限'
        }
      ],
      // 菜单列表
      menuOptions: [] as any[],
      // 部门列表
      deptOptions: [] as any[],
      // 查询参数
      queryParams: {
        page: 1,
        size: 10,
        roleName: undefined,
        roleKey: undefined,
        status: undefined,
        start: null,
        end: null
      },
      // 表单参数
      form: {} as any,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // 表单校验
      rules: {
        roleName: [
          {required: true, message: '角色名称不能为空', trigger: 'blur'}
        ],
        roleKey: [
          {required: true, message: '权限字符不能为空', trigger: 'blur'}
        ],
        roleSort: [
          {required: true, message: '角色顺序不能为空', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    indexMethod(index) {
      return index + (this.queryParams.page -1)* this.queryParams.size + 1;
    },
    searchFormEffects($: EffectsContext) {
      getDicts('sys_normal_disable').then((response) => {
        this.statusOptions = response.data;
        $('status').setEnum(response.data);
      });
    },
    /** 查询角色列表 */
    getList() {
      this.loading = true;
      if(this.dateRange != null && this.dateRange.length > 0) {
        this.queryParams.start = (this.dateRange[0] + ' 00:00:00');
      }else {
        this.queryParams.start = null
      }
      if(this.dateRange != null && this.dateRange.length > 1) {
        this.queryParams.end = (this.dateRange[1] + ' 23:59:59');
      }else {
        this.queryParams.end = null
      }
      const params = {...this.queryParams, page: this.queryParams.page - 1};
      listRole(params).then((data) => {
        console.info(data)
        this.roleList = data.rows;
        this.total = data.total || 0;
        this.loading = false;
      });
    },
    /** 查询菜单树结构 */
    getMenuTreeselect() {
      menuTreeselect().then((response) => {
        this.menuOptions = response.data;
      });
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      // 目前被选中的菜单节点
      let checkedKeys = (this.$refs.menu as ElTree<any, any>).getCheckedKeys();
      // 半选中的菜单节点
      let halfCheckedKeys = (this.$refs.menu as ElTree<any,
        any>).getHalfCheckedKeys();
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    },
    // 所有部门节点数据
    getDeptAllCheckedKeys() {
      // 目前被选中的部门节点
      let checkedKeys = (this.$refs.dept as ElTree<any, any>).getCheckedKeys();
      // 半选中的部门节点
      let halfCheckedKeys = (this.$refs.dept as ElTree<any,
        any>).getHalfCheckedKeys();
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    },
    /** 根据角色ID查询菜单树结构 */
    getRoleMenuTreeselect(roleId) {
      return roleMenuTreeselect(roleId).then((response) => {
        this.menuOptions = response.menus;
        return response;
      });
    },
    /** 根据角色ID查询部门树结构 */
    getRoleDeptTreeselect(roleId) {
      return roleDeptTreeselect(roleId).then((response) => {
        this.deptOptions = response.depts;
        return response;
      });
    },
    // 角色状态修改
    handleStatusChange(row) {
      let text = row.status === '0' ? '启用' : '停用';
      this.$confirm(
        '确认要"' + text + '""' + row.roleName + '"角色吗?',
        '警告',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() =>
          api.system.role.changeStatus.r({
            roleId: row.roleId,
            status: row.status
          })
        )
        .then(() => {
          msgSuccess(text + '成功');
        })
        .catch(() => {
          row.status = row.status === '0' ? '1' : '0';
        });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 取消按钮（数据权限）
    cancelDataScope() {
      this.openDataScope = false;
      this.reset();
    },
    // 表单重置
    reset() {
      if (this.$refs.menu != undefined) {
        (this.$refs.menu as ElTree<any, any>).setCheckedKeys([]);
      }
      (this.menuExpand = false),
        (this.menuNodeAll = false),
        (this.deptExpand = true),
        (this.deptNodeAll = false),
        (this.form = {
          roleId: undefined,
          roleName: undefined,
          roleKey: undefined,
          roleSort: 0,
          status: '0',
          menuIds: [],
          deptIds: [],
          menuCheckStrictly: true,
          deptCheckStrictly: true,
          remark: undefined
        });
      this.resetForm('form');
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      // this.resetForm('queryForm');
      this.queryParams = {
          page: 1,
          size: 10,
          roleName: undefined,
          roleKey: undefined,
          status: undefined
      }
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.roleId);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    // 树权限（展开/折叠）
    handleCheckedTreeExpand(value, type) {
      if (type == 'menu') {
        let treeList = this.menuOptions;
        const store = (this.$refs.menu as ElTree<any, any>).store as any;
        for (let i = 0; i < treeList.length; i++) {
          store.nodesMap[treeList[i].id].expanded = value;
        }
      } else if (type == 'dept') {
        let treeList = this.deptOptions;
        const store = (this.$refs.dept as ElTree<any, any>).store as any;
        for (let i = 0; i < treeList.length; i++) {
          store.nodesMap[treeList[i].id].expanded = value;
        }
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value, type) {
      if (type == 'menu') {
        (this.$refs.menu as ElTree<any, any>).setCheckedNodes(
          value ? this.menuOptions : []
        );
      } else if (type == 'dept') {
        (this.$refs.dept as ElTree<any, any>).setCheckedNodes(
          value ? this.deptOptions : []
        );
      }
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect(value, type) {
      if (type == 'menu') {
        this.form.menuCheckStrictly = !!value;
      } else if (type == 'dept') {
        this.form.deptCheckStrictly = !!value;
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.getMenuTreeselect();
      this.open = true;
      this.title = '添加角色';
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const roleId = row.roleId || this.ids;
      const roleMenu = this.getRoleMenuTreeselect(roleId);
      api.system.role.getInfo.requestData(roleId).then((data) => {
        this.form = data;
        this.open = true;
        this.$nextTick(() => {
          roleMenu.then((res) => {
            let checkedKeys = data.menuIds || [];
            checkedKeys.forEach((v) => {
              this.$nextTick(() => {
                (this.$refs.menu as ElTree<any, any>).setChecked(
                  v,
                  true,
                  false
                );
              });
            });
          });
        });
        this.title = '修改角色';
      });
    },
    /** 选择角色权限范围触发 */
    dataScopeSelectChange(value) {
      if (value !== '2') {
        (this.$refs.dept as ElTree<any, any>).setCheckedKeys([]);
      }
    },
    /** 分配数据权限操作 */
    handleDataScope(row) {
      this.reset();
      const roleDeptTreeSelect = this.getRoleDeptTreeselect(row.roleId);
      api.system.role.getInfo.requestData(row.roleId).then((data) => {
        this.form = data;
        this.openDataScope = true;
        this.$nextTick(() => {
          roleDeptTreeSelect.then(() => {
            (this.$refs.dept as ElTree<any, any>).setCheckedKeys(data.deptIds!);
          });
        });
        this.title = '分配数据权限';
      });
    },
    /** 提交按钮 */
    submitForm() {
      (this.$refs['form'] as ElForm).validate((valid) => {
        if (valid) {
          if (this.form.roleId != undefined) {
            this.form.menuIds = this.getMenuAllCheckedKeys();
            api.system.role.edit.r(this.form).then(() => {
              msgSuccess('修改成功');
              this.open = false;
              this.getList();
            });
          } else {
            this.form.menuIds = this.getMenuAllCheckedKeys();
            api.system.role.add.r(this.form).then(() => {
              msgSuccess('新增成功');
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 提交按钮（数据权限） */
    submitDataScope() {
      if (this.form.roleId != undefined) {
        this.form.deptIds = this.getDeptAllCheckedKeys();
        api.system.role.dataScope.r(this.form).then(() => {
          msgSuccess('修改成功');
          this.openDataScope = false;
          this.getList();
        });
      }
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const roleIds = row.roleId || this.ids;
      this.$confirm(
        '是否确认删除角色编号为"' + roleIds + '"的数据项?',
        '警告',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => api.system.role.remove.r({roleIds}))
        .then(() => {
          this.getList();
          msgSuccess('删除成功');
        });
    },
    /** 导出按钮操作 */
    handleExport() {
      const queryParams = {
        ...this.queryParams,
        page: this.queryParams.page - 1
      };
      this.$confirm('是否确认导出所有角色数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => api.system.role.export.r(queryParams))
        .then((value) => {
          download(value);
        });
    }
  }
});
